/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button } from 'reactstrap';
import { getDefaultConfig } from '../../config/app-config';
import { useAppClickHandlers } from '../../hooks/useAppClickHandlers';
import SGXStockImage from '../../images/sgx-esgenome-stock-image.png';
import { useAppSelector } from '../../reducers';
import DisambiguationModal, { DisambiguationModalProps } from '../home/partials/DisambiguationModal';
import './styles.scss';
import config from '../../config';
import { useSearchParams } from '../../hooks/useSearchParams';
import { ReferralInfoType } from '../../types/onboarding';

export function SGXEsgenome() {
  const searchParams = useSearchParams();
  const referralInfo: ReferralInfoType = {
    referralCode: searchParams.get('referralCode'),
    referralName: searchParams.get('referralName'),
  };

  const [disambiguationModal, setDisambiguationModal] = useState<DisambiguationModalProps | undefined>(undefined);
  const isLoggedIn = useAppSelector((state) => state.currentUser.loaded);

  const clickHandlers = useAppClickHandlers({ setDisambiguationModal });
  const handleLogin = () => clickHandlers.GoToCompanyTrackerLight();
  const handleSignUp = () => clickHandlers.GoToCompanyTrackerRegistration({
    referralInfo,
    onboardingPath: 'sgx-esgenome'
  });
  const showRegisterButton = !isLoggedIn && getDefaultConfig().branding.ctlApp.canRegister;

  return (
    <>
      <div className='sgx-esgenome-container'>
        {disambiguationModal ? <DisambiguationModal {...disambiguationModal} /> : null}
        <div className='cover d-flex flex-column flex-lg-row'>
          <div className='text p-3 mr-5 d-flex flex-column justify-content-between'>
            <div className='headline'>Tell Your Sustainability Story with
              <div className='headline'>SGX ESGenome</div>
            </div>

            <div className='description'>
              <p>An initiative by Singapore Exchange, SGX ESGenome is an ESG disclosure platform to support issuers in their ESG disclosure journey.</p>
              <p>For more information, contact <a href='mailto:ESGenome@sgx.com'>ESGenome@sgx.com</a></p>
            </div>
            <div className='action-buttons'>
              <Button className='mr-2' outline={true} onClick={handleLogin}>
                {isLoggedIn ? 'ACCESS' : 'LOGIN'}<i className='ml-3 fa fa-arrow-right' />
              </Button>
              {showRegisterButton ?
                <Button data-testid='sgx-registration-btn' onClick={handleSignUp}>
                  SIGN UP<i className='ml-3 fa fa-arrow-right' />
                </Button>
                : null}
            </div>
          </div>
          <div className='image d-none d-lg-inline-block'>
            <img src={SGXStockImage} width={615} height={629} alt='SGX ESGenome' />
          </div>
        </div>
        <div className='disclaimer mt-3 p-lg-0'>
          The access and/or use of SGX ESGenome is governed by the SGXNet User Terms & Conditions (which can be
          accessed <a href={config.sgx.termsAndConditionsPdf} rel='noreferrer' target={'_blank'}>here</a>)
          ("SGXNet T&Cs") and the ESG Portal Addendum to the SGXNet T&Cs (which can
          be accessed <a href={config.sgx.addendumTermsLink} rel='noreferrer' target={'_blank'}>here</a>)
          ("ESG Addendum", and together with the SGXNet T&Cs, the "SGXNet ESG T&Cs").

          When accessing and using SGX ESGenome for the first time, you will be directed to a page where you will
          be required to expressly acknowledge that you agree to comply with and be bound, by the SGXNet ESG T&Cs.

          Your continued access and/or use of SGX ESGenome will be deemed to constitute your acceptance of the SGXNet
          ESG T&Cs (including any variations, modifications and amendments to the SGXNet ESG T&Cs).
          <br />
          <br />
          The term ‘you’ or ‘your’, where used above, refers to a viewer or user of SGX ESGenome.
        </div>
      </div>
    </>
  );
}
